// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b6b6b%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><polyline points=%276 9 12 15 18 9%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #ffffff;
  --fg: #1b1b1b;
  --muted: #6b6b6b;
  --accent: #22785a;
  --accent-fg: #ffffff;
  --border: #e3e3e3;
  --bubble-user: #eef6f2;
  --bubble-tool: #f5f5f5;
  --danger: #b3261e;
}

* { box-sizing: border-box; }

html, body {
  margin: 0;
  height: 100%;
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  font-size: 14px;
  color: var(--fg);
  background: var(--bg);
}

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  /* Office overlays its own info (i) button at the far-right of the task pane.
     Reserve space on the right so our settings/conversations buttons aren't
     hidden underneath it. */
  padding-right: 34px;
  border-bottom: 1px solid var(--border);
}
.brand { display: flex; align-items: center; gap: 8px; font-weight: 600; flex: 0 0 auto; }
.brand .dot { width: 10px; height: 10px; border-radius: 50%; background: var(--accent); }
.topbar-right { display: flex; align-items: center; gap: 6px; min-width: 0; flex: 1; justify-content: flex-end; }
.pill {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f0f0f0;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
.pill.connected { background: var(--bubble-user); color: var(--accent); }
.token-info {
  font-size: 11px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #f0f0f0;
  color: var(--muted);
  white-space: nowrap;
  flex: 0 0 auto;
}
.token-info.token-warn { background: #fff3cd; color: #856404; }
.token-info.token-critical { background: #f8d7da; color: #721c24; }
.icon-btn {
  border: none; background: transparent; cursor: pointer;
  font-size: 16px; line-height: 1; padding: 5px;
  border-radius: 6px;
}
.icon-btn:hover { background: var(--bubble-tool); }

.panel {
  padding: 14px;
  border-bottom: 1px solid var(--border);
  overflow-y: auto;
}
.panel h2 { margin: 0 0 12px; font-size: 15px; }
.settings-title { margin: 0 0 10px; font-size: 14px; font-weight: 600; }
.settings-section { margin-top: 6px; }
.field { display: flex; flex-direction: column; gap: 5px; margin-bottom: 14px; }
.field > span { font-size: 12px; color: var(--muted); font-weight: 500; }
.field.checkbox { flex-direction: row; align-items: flex-start; gap: 8px; }
.field.checkbox span { font-size: 12px; }
input[type="text"], input[type="email"], input[type="password"], input[type="number"], select, textarea {
  width: 100%;
  display: block;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  background: var(--bg);
  color: var(--fg);
  transition: border-color .12s, box-shadow .12s;
}
/* Make <select> match the text inputs exactly (native macOS selects render
   with their own chrome/height otherwise) and add a consistent chevron. */
select {
  -webkit-appearance: none;
  appearance: none;
  height: 40px;
  padding-right: 32px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
}
input[type="text"], input[type="email"], input[type="password"], input[type="number"] { height: 40px; }
input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(34, 120, 90, .12);
}
.hint { color: var(--muted); font-size: 11px; }
.hint-link { display: inline-block; margin-top: 8px; color: var(--accent); font-size: 12px; }
.form-error { display: block; color: var(--danger); font-size: 12px; min-height: 16px; margin: 2px 0 6px; }
.settings-actions { flex-wrap: wrap; }

/* ── Profile + quota card ── */
.profile {
  background: linear-gradient(180deg, var(--bubble-user), var(--bg));
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 16px;
}
.profile-head { display: flex; align-items: center; gap: 10px; }
.avatar {
  width: 38px; height: 38px; border-radius: 50%;
  background: var(--accent); color: var(--accent-fg);
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 16px; text-transform: uppercase; flex: 0 0 auto;
}
.profile-id { min-width: 0; }
.profile-email { font-weight: 600; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.profile-role { font-size: 11px; color: var(--muted); text-transform: capitalize; }
.quota { margin-top: 12px; }
.quota-row { display: flex; justify-content: space-between; align-items: baseline; font-size: 12px; color: var(--muted); }
.quota-text { font-weight: 600; color: var(--fg); font-size: 12px; }
.quota-bar { height: 7px; background: #e9efec; border-radius: 4px; overflow: hidden; margin-top: 5px; }
.quota-bar > i { display: block; height: 100%; width: 0; background: var(--accent); border-radius: 4px; transition: width .3s; }
.quota-bar > i.warn { background: #d98a00; }
.quota-bar > i.full { background: var(--danger); }
.quota-sub { font-size: 11px; color: var(--muted); margin-top: 5px; }

.row { display: flex; gap: 8px; margin-top: 6px; }
button.primary {
  background: var(--accent); color: var(--accent-fg);
  border: none; border-radius: 6px; padding: 8px 14px;
  cursor: pointer; font-size: 13px; font-weight: 600;
}
button.primary:disabled { opacity: .5; cursor: default; }
button.ghost {
  background: transparent; color: var(--fg);
  border: 1px solid var(--border); border-radius: 6px;
  padding: 8px 14px; cursor: pointer; font-size: 13px;
}
button.danger {
  background: var(--danger); color: #fff;
  border: none; border-radius: 6px; padding: 8px 14px;
  cursor: pointer; font-size: 13px; font-weight: 600;
}
button.danger:hover { opacity: 0.9; }

.chat { flex: 1; overflow-y: auto; }
.messages { display: flex; flex-direction: column; gap: 10px; padding: 14px; }
.msg { padding: 10px 12px; border-radius: 10px; line-height: 1.45; white-space: pre-wrap; word-break: break-word; }
.msg.system { background: var(--bubble-tool); color: var(--muted); font-size: 12.5px; }
.msg.user { background: var(--bubble-user); align-self: flex-end; max-width: 90%; }
.msg.assistant { background: #fafafa; border: 1px solid var(--border); }
.msg.error { background: #fdecea; color: var(--danger); }
.msg .tool {
  font-family: ui-monospace, "Cascadia Code", monospace;
  font-size: 11.5px; color: var(--muted);
  background: var(--bubble-tool); border-radius: 6px;
  padding: 6px 8px; margin-top: 4px;
}
.msg .tool.undo-hint {
  font-family: inherit;
  color: var(--accent, #2563eb);
  background: transparent;
  padding: 6px 0 2px;
}

.composer {
  display: flex; gap: 8px; padding: 10px;
  align-items: flex-end;
  border-top: 1px solid var(--border);
}
.composer textarea {
  resize: none; flex: 1;
  min-height: 40px; max-height: 140px;
  padding: 10px 12px; line-height: 1.4;
}
/* Compact circular send/stop button (icon only). */
.send-btn {
  flex: 0 0 auto;
  width: 40px; height: 40px;
  padding: 0;
  border-radius: 50%;
  font-size: 15px; line-height: 1;
  display: flex; align-items: center; justify-content: center;
}
.send-btn.primary { font-weight: 400; }

.overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.35);
  display: flex; align-items: center; justify-content: center; padding: 20px;
}
.modal {
  background: #fff; border-radius: 10px; padding: 16px;
  width: 100%; max-width: 360px; box-shadow: 0 10px 30px rgba(0,0,0,.2);
}
.modal h3 { margin: 0 0 8px; }
.modal pre {
  background: var(--bubble-tool); padding: 8px; border-radius: 6px;
  font-size: 11.5px; max-height: 180px; overflow: auto; white-space: pre-wrap;
}
.hidden { display: none !important; }
.typing { color: var(--muted); font-style: italic; }

/* ── Markdown content styles ── */
.msg.assistant {
  white-space: normal;  /* override the global .msg pre-wrap */
}
.msg.assistant h1,
.msg.assistant h2,
.msg.assistant h3,
.msg.assistant h4 {
  margin: 12px 0 6px;
  line-height: 1.3;
}
.msg.assistant h1 { font-size: 16px; }
.msg.assistant h2 { font-size: 15px; }
.msg.assistant h3 { font-size: 14px; }

.msg.assistant p {
  margin: 4px 0;
}

.msg.assistant ul,
.msg.assistant ol {
  margin: 4px 0;
  padding-left: 20px;
}

.msg.assistant li {
  margin: 2px 0;
}

/* Code blocks */
.msg.assistant pre {
  background: #f5f5f5;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px 10px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.4;
  margin: 6px 0;
}

.msg.assistant code {
  font-family: ui-monospace, "Cascadia Code", "Consolas", monospace;
  font-size: 12px;
}

/* Inline code */
.msg.assistant p code,
.msg.assistant li code {
  background: #f0f0f0;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}

/* Tables */
.msg.assistant table {
  border-collapse: collapse;
  margin: 6px 0;
  font-size: 12.5px;
  width: 100%;
}

.msg.assistant th,
.msg.assistant td {
  border: 1px solid var(--border);
  padding: 4px 8px;
  text-align: left;
}

.msg.assistant th {
  background: #f5f5f5;
  font-weight: 600;
}

.msg.assistant tr:nth-child(even) {
  background: #fafafa;
}

/* Blockquotes */
.msg.assistant blockquote {
  border-left: 3px solid var(--accent);
  margin: 6px 0;
  padding: 4px 10px;
  color: var(--muted);
  background: #f9f9f9;
}

/* Links */
.msg.assistant a {
  color: var(--accent);
  text-decoration: none;
}
.msg.assistant a:hover {
  text-decoration: underline;
}

/* Horizontal rules */
.msg.assistant hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 8px 0;
}

/* ── Conversation list styles ── */
.conv-actions {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.conv-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  overflow-y: auto;
}

.conv-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.conv-item:hover {
  background: #f9f9f9;
  border-color: var(--accent);
}

.conv-item.active {
  background: var(--bubble-user);
  border-color: var(--accent);
}

.conv-item-info {
  flex: 1;
  min-width: 0;
}

.conv-item-name {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conv-item-meta {
  font-size: 11px;
  color: var(--muted);
  margin-top: 2px;
}

.conv-item-actions {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.conv-item-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 4px;
  opacity: 0.6;
}

.conv-item-btn:hover {
  opacity: 1;
  background: rgba(0,0,0,0.05);
}

.conv-item-btn.delete:hover {
  background: rgba(179, 38, 30, 0.1);
  color: var(--danger);
}

.conv-empty {
  text-align: center;
  color: var(--muted);
  font-size: 13px;
  padding: 24px;
}

button.small {
  padding: 6px 10px;
  font-size: 12px;
}

.file-label {
  display: inline-block;
  cursor: pointer;
}

.file-label input[type="file"] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;EACE,SAAS;EACT,YAAY;EACZ,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB;;4BAE0B;EAC1B,mBAAmB;EACnB,sCAAsC;AACxC;AACA,SAAS,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF,cAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACxF,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,OAAO,EAAE,yBAAyB,EAAE;AAChH;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,kBAAkB,8BAA8B,EAAE,oBAAoB,EAAE;AACxE;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE;EACE,YAAY,EAAE,uBAAuB,EAAE,eAAe;EACtD,eAAe,EAAE,cAAc,EAAE,YAAY;EAC7C,kBAAkB;AACpB;AACA,kBAAkB,8BAA8B,EAAE;;AAElD;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;AACA,YAAY,gBAAgB,EAAE,eAAe,EAAE;AAC/C,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvE,oBAAoB,eAAe,EAAE;AACrC,SAAS,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC/E,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACxE,kBAAkB,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC1E,uBAAuB,eAAe,EAAE;AACxC;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;0EAC0E;AAC1E;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yDAA8Q;EAC9Q,4BAA4B;EAC5B,sCAAsC;AACxC;AACA,wFAAwF,YAAY,EAAE;AACtG;EACE,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA,QAAQ,mBAAmB,EAAE,eAAe,EAAE;AAC9C,aAAa,qBAAqB,EAAE,eAAe,EAAE,oBAAoB,EAAE,eAAe,EAAE;AAC5F,cAAc,cAAc,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC1G,oBAAoB,eAAe,EAAE;;AAErC,+BAA+B;AAC/B;EACE,kEAAkE;EAClE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC/D;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,yBAAyB,EAAE,uBAAuB;EAClD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,cAAc;AAC9E;AACA,cAAc,YAAY,EAAE;AAC5B,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpH,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;AAClF,SAAS,gBAAgB,EAAE;AAC3B,aAAa,aAAa,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACzH,cAAc,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnE,aAAa,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtG,iBAAiB,cAAc,EAAE,YAAY,EAAE,QAAQ,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AAC/H,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,yBAAyB,EAAE;AACjD,aAAa,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEpE,OAAO,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACjD;EACE,yBAAyB,EAAE,uBAAuB;EAClD,YAAY,EAAE,kBAAkB,EAAE,iBAAiB;EACnD,eAAe,EAAE,eAAe,EAAE,gBAAgB;AACpD;AACA,0BAA0B,WAAW,EAAE,eAAe,EAAE;AACxD;EACE,uBAAuB,EAAE,gBAAgB;EACzC,+BAA+B,EAAE,kBAAkB;EACnD,iBAAiB,EAAE,eAAe,EAAE,eAAe;AACrD;AACA;EACE,yBAAyB,EAAE,WAAW;EACtC,YAAY,EAAE,kBAAkB,EAAE,iBAAiB;EACnD,eAAe,EAAE,eAAe,EAAE,gBAAgB;AACpD;AACA,sBAAsB,YAAY,EAAE;;AAEpC,QAAQ,OAAO,EAAE,gBAAgB,EAAE;AACnC,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,aAAa,EAAE;AAC7E,OAAO,kBAAkB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AAClH,cAAc,8BAA8B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACtF,YAAY,8BAA8B,EAAE,oBAAoB,EAAE,cAAc,EAAE;AAClF,iBAAiB,mBAAmB,EAAE,+BAA+B,EAAE;AACvE,aAAa,mBAAmB,EAAE,oBAAoB,EAAE;AACxD;EACE,qDAAqD;EACrD,iBAAiB,EAAE,mBAAmB;EACtC,8BAA8B,EAAE,kBAAkB;EAClD,gBAAgB,EAAE,eAAe;AACnC;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,QAAQ,EAAE,aAAa;EACtC,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,YAAY,EAAE,OAAO;EACrB,gBAAgB,EAAE,iBAAiB;EACnC,kBAAkB,EAAE,gBAAgB;AACtC;AACA,mDAAmD;AACnD;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe,EAAE,cAAc;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,oBAAoB,gBAAgB,EAAE;;AAEtC;EACE,eAAe,EAAE,QAAQ,EAAE,2BAA2B;EACtD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa;AAC5E;AACA;EACE,gBAAgB,EAAE,mBAAmB,EAAE,aAAa;EACpD,WAAW,EAAE,gBAAgB,EAAE,sCAAsC;AACvE;AACA,YAAY,eAAe,EAAE;AAC7B;EACE,8BAA8B,EAAE,YAAY,EAAE,kBAAkB;EAChE,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE,qBAAqB;AAC7E;AACA,UAAU,wBAAwB,EAAE;AACpC,UAAU,mBAAmB,EAAE,kBAAkB,EAAE;;AAEnD,kCAAkC;AAClC;EACE,mBAAmB,GAAG,sCAAsC;AAC9D;AACA;;;;EAIE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,oBAAoB,eAAe,EAAE;AACrC,oBAAoB,eAAe,EAAE;AACrC,oBAAoB,eAAe,EAAE;;AAErC;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iEAAiE;EACjE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --bg: #ffffff;\n  --fg: #1b1b1b;\n  --muted: #6b6b6b;\n  --accent: #22785a;\n  --accent-fg: #ffffff;\n  --border: #e3e3e3;\n  --bubble-user: #eef6f2;\n  --bubble-tool: #f5f5f5;\n  --danger: #b3261e;\n}\n\n* { box-sizing: border-box; }\n\nhtml, body {\n  margin: 0;\n  height: 100%;\n  font-family: \"Segoe UI\", system-ui, -apple-system, sans-serif;\n  font-size: 14px;\n  color: var(--fg);\n  background: var(--bg);\n}\n\n#app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  /* Office overlays its own info (i) button at the far-right of the task pane.\n     Reserve space on the right so our settings/conversations buttons aren't\n     hidden underneath it. */\n  padding-right: 34px;\n  border-bottom: 1px solid var(--border);\n}\n.brand { display: flex; align-items: center; gap: 8px; font-weight: 600; flex: 0 0 auto; }\n.brand .dot { width: 10px; height: 10px; border-radius: 50%; background: var(--accent); }\n.topbar-right { display: flex; align-items: center; gap: 6px; min-width: 0; flex: 1; justify-content: flex-end; }\n.pill {\n  font-size: 11px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f0f0f0;\n  color: var(--muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n}\n.pill.connected { background: var(--bubble-user); color: var(--accent); }\n.token-info {\n  font-size: 11px;\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: #f0f0f0;\n  color: var(--muted);\n  white-space: nowrap;\n  flex: 0 0 auto;\n}\n.token-info.token-warn { background: #fff3cd; color: #856404; }\n.token-info.token-critical { background: #f8d7da; color: #721c24; }\n.icon-btn {\n  border: none; background: transparent; cursor: pointer;\n  font-size: 16px; line-height: 1; padding: 5px;\n  border-radius: 6px;\n}\n.icon-btn:hover { background: var(--bubble-tool); }\n\n.panel {\n  padding: 14px;\n  border-bottom: 1px solid var(--border);\n  overflow-y: auto;\n}\n.panel h2 { margin: 0 0 12px; font-size: 15px; }\n.settings-title { margin: 0 0 10px; font-size: 14px; font-weight: 600; }\n.settings-section { margin-top: 6px; }\n.field { display: flex; flex-direction: column; gap: 5px; margin-bottom: 14px; }\n.field > span { font-size: 12px; color: var(--muted); font-weight: 500; }\n.field.checkbox { flex-direction: row; align-items: flex-start; gap: 8px; }\n.field.checkbox span { font-size: 12px; }\ninput[type=\"text\"], input[type=\"email\"], input[type=\"password\"], input[type=\"number\"], select, textarea {\n  width: 100%;\n  display: block;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  background: var(--bg);\n  color: var(--fg);\n  transition: border-color .12s, box-shadow .12s;\n}\n/* Make <select> match the text inputs exactly (native macOS selects render\n   with their own chrome/height otherwise) and add a consistent chevron. */\nselect {\n  -webkit-appearance: none;\n  appearance: none;\n  height: 40px;\n  padding-right: 32px;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b6b6b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n}\ninput[type=\"text\"], input[type=\"email\"], input[type=\"password\"], input[type=\"number\"] { height: 40px; }\ninput:focus, select:focus, textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(34, 120, 90, .12);\n}\n.hint { color: var(--muted); font-size: 11px; }\n.hint-link { display: inline-block; margin-top: 8px; color: var(--accent); font-size: 12px; }\n.form-error { display: block; color: var(--danger); font-size: 12px; min-height: 16px; margin: 2px 0 6px; }\n.settings-actions { flex-wrap: wrap; }\n\n/* ── Profile + quota card ── */\n.profile {\n  background: linear-gradient(180deg, var(--bubble-user), var(--bg));\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 14px;\n  margin-bottom: 16px;\n}\n.profile-head { display: flex; align-items: center; gap: 10px; }\n.avatar {\n  width: 38px; height: 38px; border-radius: 50%;\n  background: var(--accent); color: var(--accent-fg);\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 700; font-size: 16px; text-transform: uppercase; flex: 0 0 auto;\n}\n.profile-id { min-width: 0; }\n.profile-email { font-weight: 600; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.profile-role { font-size: 11px; color: var(--muted); text-transform: capitalize; }\n.quota { margin-top: 12px; }\n.quota-row { display: flex; justify-content: space-between; align-items: baseline; font-size: 12px; color: var(--muted); }\n.quota-text { font-weight: 600; color: var(--fg); font-size: 12px; }\n.quota-bar { height: 7px; background: #e9efec; border-radius: 4px; overflow: hidden; margin-top: 5px; }\n.quota-bar > i { display: block; height: 100%; width: 0; background: var(--accent); border-radius: 4px; transition: width .3s; }\n.quota-bar > i.warn { background: #d98a00; }\n.quota-bar > i.full { background: var(--danger); }\n.quota-sub { font-size: 11px; color: var(--muted); margin-top: 5px; }\n\n.row { display: flex; gap: 8px; margin-top: 6px; }\nbutton.primary {\n  background: var(--accent); color: var(--accent-fg);\n  border: none; border-radius: 6px; padding: 8px 14px;\n  cursor: pointer; font-size: 13px; font-weight: 600;\n}\nbutton.primary:disabled { opacity: .5; cursor: default; }\nbutton.ghost {\n  background: transparent; color: var(--fg);\n  border: 1px solid var(--border); border-radius: 6px;\n  padding: 8px 14px; cursor: pointer; font-size: 13px;\n}\nbutton.danger {\n  background: var(--danger); color: #fff;\n  border: none; border-radius: 6px; padding: 8px 14px;\n  cursor: pointer; font-size: 13px; font-weight: 600;\n}\nbutton.danger:hover { opacity: 0.9; }\n\n.chat { flex: 1; overflow-y: auto; }\n.messages { display: flex; flex-direction: column; gap: 10px; padding: 14px; }\n.msg { padding: 10px 12px; border-radius: 10px; line-height: 1.45; white-space: pre-wrap; word-break: break-word; }\n.msg.system { background: var(--bubble-tool); color: var(--muted); font-size: 12.5px; }\n.msg.user { background: var(--bubble-user); align-self: flex-end; max-width: 90%; }\n.msg.assistant { background: #fafafa; border: 1px solid var(--border); }\n.msg.error { background: #fdecea; color: var(--danger); }\n.msg .tool {\n  font-family: ui-monospace, \"Cascadia Code\", monospace;\n  font-size: 11.5px; color: var(--muted);\n  background: var(--bubble-tool); border-radius: 6px;\n  padding: 6px 8px; margin-top: 4px;\n}\n.msg .tool.undo-hint {\n  font-family: inherit;\n  color: var(--accent, #2563eb);\n  background: transparent;\n  padding: 6px 0 2px;\n}\n\n.composer {\n  display: flex; gap: 8px; padding: 10px;\n  align-items: flex-end;\n  border-top: 1px solid var(--border);\n}\n.composer textarea {\n  resize: none; flex: 1;\n  min-height: 40px; max-height: 140px;\n  padding: 10px 12px; line-height: 1.4;\n}\n/* Compact circular send/stop button (icon only). */\n.send-btn {\n  flex: 0 0 auto;\n  width: 40px; height: 40px;\n  padding: 0;\n  border-radius: 50%;\n  font-size: 15px; line-height: 1;\n  display: flex; align-items: center; justify-content: center;\n}\n.send-btn.primary { font-weight: 400; }\n\n.overlay {\n  position: fixed; inset: 0; background: rgba(0,0,0,.35);\n  display: flex; align-items: center; justify-content: center; padding: 20px;\n}\n.modal {\n  background: #fff; border-radius: 10px; padding: 16px;\n  width: 100%; max-width: 360px; box-shadow: 0 10px 30px rgba(0,0,0,.2);\n}\n.modal h3 { margin: 0 0 8px; }\n.modal pre {\n  background: var(--bubble-tool); padding: 8px; border-radius: 6px;\n  font-size: 11.5px; max-height: 180px; overflow: auto; white-space: pre-wrap;\n}\n.hidden { display: none !important; }\n.typing { color: var(--muted); font-style: italic; }\n\n/* ── Markdown content styles ── */\n.msg.assistant {\n  white-space: normal;  /* override the global .msg pre-wrap */\n}\n.msg.assistant h1,\n.msg.assistant h2,\n.msg.assistant h3,\n.msg.assistant h4 {\n  margin: 12px 0 6px;\n  line-height: 1.3;\n}\n.msg.assistant h1 { font-size: 16px; }\n.msg.assistant h2 { font-size: 15px; }\n.msg.assistant h3 { font-size: 14px; }\n\n.msg.assistant p {\n  margin: 4px 0;\n}\n\n.msg.assistant ul,\n.msg.assistant ol {\n  margin: 4px 0;\n  padding-left: 20px;\n}\n\n.msg.assistant li {\n  margin: 2px 0;\n}\n\n/* Code blocks */\n.msg.assistant pre {\n  background: #f5f5f5;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 8px 10px;\n  overflow-x: auto;\n  font-size: 12px;\n  line-height: 1.4;\n  margin: 6px 0;\n}\n\n.msg.assistant code {\n  font-family: ui-monospace, \"Cascadia Code\", \"Consolas\", monospace;\n  font-size: 12px;\n}\n\n/* Inline code */\n.msg.assistant p code,\n.msg.assistant li code {\n  background: #f0f0f0;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n/* Tables */\n.msg.assistant table {\n  border-collapse: collapse;\n  margin: 6px 0;\n  font-size: 12.5px;\n  width: 100%;\n}\n\n.msg.assistant th,\n.msg.assistant td {\n  border: 1px solid var(--border);\n  padding: 4px 8px;\n  text-align: left;\n}\n\n.msg.assistant th {\n  background: #f5f5f5;\n  font-weight: 600;\n}\n\n.msg.assistant tr:nth-child(even) {\n  background: #fafafa;\n}\n\n/* Blockquotes */\n.msg.assistant blockquote {\n  border-left: 3px solid var(--accent);\n  margin: 6px 0;\n  padding: 4px 10px;\n  color: var(--muted);\n  background: #f9f9f9;\n}\n\n/* Links */\n.msg.assistant a {\n  color: var(--accent);\n  text-decoration: none;\n}\n.msg.assistant a:hover {\n  text-decoration: underline;\n}\n\n/* Horizontal rules */\n.msg.assistant hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 8px 0;\n}\n\n/* ── Conversation list styles ── */\n.conv-actions {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.conv-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.conv-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.conv-item:hover {\n  background: #f9f9f9;\n  border-color: var(--accent);\n}\n\n.conv-item.active {\n  background: var(--bubble-user);\n  border-color: var(--accent);\n}\n\n.conv-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.conv-item-name {\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conv-item-meta {\n  font-size: 11px;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.conv-item-actions {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.conv-item-btn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 4px 6px;\n  border-radius: 4px;\n  opacity: 0.6;\n}\n\n.conv-item-btn:hover {\n  opacity: 1;\n  background: rgba(0,0,0,0.05);\n}\n\n.conv-item-btn.delete:hover {\n  background: rgba(179, 38, 30, 0.1);\n  color: var(--danger);\n}\n\n.conv-empty {\n  text-align: center;\n  color: var(--muted);\n  font-size: 13px;\n  padding: 24px;\n}\n\nbutton.small {\n  padding: 6px 10px;\n  font-size: 12px;\n}\n\n.file-label {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.file-label input[type=\"file\"] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
